/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { ConfirmationDialog } from '@mummssoftware/common-ui';
import { HCPCSGlobalContext } from '@mummssoftware/global-context';
import { SubmitHCPCS } from './SubmitHCPCS';
import { HCPCSMenu } from './HCPCSMenu';
import { EditHCPCS } from './EditHCPCS';
import defaults from '../../../../translations/en.json';

export const EditHCPCSDialog = () => {
  const { showHCPCS } = useContext(HCPCSGlobalContext);

  if (!showHCPCS) {
    return null;
  }

  return (
    <>
      <ConfirmationDialog
        title={defaults.recordHCPCS}
        disableBackdropClick
        fullWidth
        maxWidth="md"
        open={showHCPCS}
        handleClick={() => null}
        noIcon
        plusIcon={<HCPCSMenu />}
        BackdropProps={{ invisible: true }}
      >
        <>
          <EditHCPCS />
          <SubmitHCPCS />
        </>
      </ConfirmationDialog>
    </>
  );
};
